import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

class Toggle extends React.Component{
    constructor(){
        super()
        this.state = {
            toggleOn: false
        }
    }
    handleChange = (e) =>{
        const value = e.target.checked
        this.setState({toggleOn: value}, ()=>this.props.onToggle(value))
    }
    componentDidMount(){
        this.setState({toggleOn: this.props.checked === null ? false : this.props.checked})
    }
    render(){
        return(
            <div className="toggle">
                <div className="toggleName">
                    {this.props.toggleName}
                </div>
                <label className="switch">
                    <input type="checkbox" checked={this.state.toggleOn} onChange={this.handleChange} />
                    <span className="slider"></span>
                </label>
                <div className="warningContainer">
                    <FontAwesomeIcon className="warningIcon" icon={faExclamationCircle} />
                    <span className="warning">{this.props.toggleMessage}</span>
                </div>
            </div>
        )
    }
}

export default Toggle